import { ReactElement, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Card, Layout, Menu, Image, Descriptions, Button,InputNumber, Modal, message } from "antd";
import { ShopOutlined, LeftOutlined, ShoppingCartOutlined } from '@ant-design/icons';
import { getAuthState } from "../../redux/selectors";
import { BUY_PRODUCT_REQUEST } from "../../redux/constants";
import "../../assets/css/index.css";
import api from "../../redux/api/axiosInstance";
import { ShopHeaderBar } from "../../components/index";
import Loading from "../../components/Loading";

export function ProductDetail(): ReactElement {
    
const dispatch = useDispatch();
const history = useHistory();
const { t } = useTranslation();
const { Content } = Layout;
const [products, setProducts] = useState<any>();
const [vendorData, setVendorData] = useState<any>();
const { productId } = useParams<{ productId: string }>();
const { currentUser } = useSelector(getAuthState);
const [loading, setLoading] = useState<boolean>(false);
const [quantity, setQuantity] = useState<any>(1);
const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
const [confirmLoading, setConfirmLoading] = useState<boolean>(false);

const onChangeQuantity = (value : any) => {
    setQuantity(value);
}

const handleOk = () => {
    setConfirmLoading(true);
    const formValue = {
        request_id : new Date().valueOf().toString(),
        seller : vendorData?.id,
        buyer : currentUser?.id,
        product_id : products?.product_id,
        qty: quantity,
        makedate : new Date()
    }
    dispatch({ type: BUY_PRODUCT_REQUEST, payload: formValue });
    setTimeout(() => {
        setIsModalVisible(false);
        setConfirmLoading(false);
        message.success(t("market.success_request_product"));
        history.go(-1);
    }, 2000);
};

const handleCancel = () => {
    setIsModalVisible(false);
};

const getProductsInfo = async () => {
    setLoading(true);
    try{
        const response = await api.post("getProductsInfo", { proID: productId})
        const { data } = response;
        const { productData, userData } = data;
        setProducts(productData);
        setVendorData(userData);
        setLoading(false);
    }
    catch(e) {
        console.log(e);
        setLoading(false);
    }
}


const getCondition = (condition : any) => {
    switch(condition) {
        case 1 :
            return "Excellent"
        case 2 :
            return "Good"
        case 3 :
            return "Heavily used"
        case 4 :
            return "New"
        default : 
            return "Excellent"
    } 
}

const requestProduct = () => {
    if(!currentUser)
    {
        history.push("/login", `${productId}`);
    }else{
        setIsModalVisible(true);
    }
}

useEffect(() => {
    getProductsInfo();
}, []);

return (
    <Layout>
        {loading && <Loading /> }
        {!currentUser && <ShopHeaderBar /> }
        <Content style={{ margin: '30px 16px 50px'}}>
            <Row justify="center" gutter={[20,10]}>
                <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                    <Image
                        src={products?.photo}
                        width="100%"
                    />
                </Col>
                <Col xs={24} sm={24} md={12} lg={16} xl={12}>
                    <Card title={products?.name} bordered={false} headStyle={{color:"#036198",fontSize:30}} style={{ width: "100%" }}>
                        <Descriptions title="" bordered style={{marginBottom:20}}>
                            <Descriptions.Item span={3} label={t("table.name")}>{products?.name}</Descriptions.Item>
                            <Descriptions.Item span={3} label={t("table.price")}>{products?.cost}</Descriptions.Item>
                            <Descriptions.Item span={3} label={t("table.auth")}>{vendorData?.club  ? vendorData.club : vendorData?.fullName}</Descriptions.Item>
                            <Descriptions.Item span={3} label={t("table.tags")}>{products?.tags}</Descriptions.Item>
                            <Descriptions.Item span={3} label={t("table.condition")}>{getCondition(products?.condition)}</Descriptions.Item>
                            <Descriptions.Item span={3} label={t("table.description")}>{products?.description}</Descriptions.Item>
                            <Descriptions.Item span={3} label={t("table.quantity")}><InputNumber size="large" min={1} max={100000} defaultValue={1} onChange={onChangeQuantity} /></Descriptions.Item>
                        </Descriptions>
                        {products?.shipping === 1 && 
                            <h1 style={{fontSize:20,color:"#036198",marginTop:30}}><ShopOutlined style={{fontSize:22,marginTop:10}} twoToneColor="#eb2f96" /> {t("market.product_shipping")}</h1>
                        }
                        
                        <Button
                            type="primary"
                            size="large"
                            style={{float:"right",marginLeft:20}}
                            onClick={()=>requestProduct()}
                            icon={<ShoppingCartOutlined />}
                        >
                            Request Product
                        </Button>
                        <Button
                            type="primary"
                            danger
                            size="large"
                            style={{float:"right"}}
                            icon={<LeftOutlined />}
                        >
                            Continue Shopping
                        </Button>
                    </Card>
                </Col>
            </Row>
        </Content>
        <Modal
            title={t("market.request_product_title")}
            visible={isModalVisible}
            onOk={handleOk}
            okText={t("market.confirm_request")}
            confirmLoading={confirmLoading}
            onCancel={handleCancel}
            cancelText={t("market.cancel_request")}
        >
            <Descriptions title="" bordered>
                <Descriptions.Item span={3} label={t("table.name")}>{products?.name}</Descriptions.Item>
                <Descriptions.Item span={3} label={t("table.quantity")}>{quantity}</Descriptions.Item>
                <Descriptions.Item span={3} label={t("market.vendor_contact")}>
                    <p>{t("table.name")}: {vendorData?.fullName}</p>
                    <a href={`mailto:${vendorData?.email}`}>{t("table.email")}: {vendorData?.email}</a><br />
                    { vendorData?.phoneNumber && <a href={`tel:${vendorData?.phoneNumber}`}>{t("table.number")}: {vendorData?.phoneNumber}</a>}
                </Descriptions.Item>
            </Descriptions>
        </Modal>
  </Layout>
  );
}
